import React from "react";

import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import {Chat, SupportAgent} from "@vedmarket/ui-kit";
import cx from "classnames";

import {COLORS} from "../../../../../../../config/constants";
type Props = {
  item: SupportRequest
  onOpen(id: string): void
}

const REQUEST_MESSAGE_COLOR = COLORS.MEDIUM_GRAY;
const REQUEST_SUBJECT_COLOR = COLORS.BLACK;

const Request = ({item, onOpen}: Props) => {

  const LastMessageIcon = item.lastMessageAuthor === 'support' ? SupportAgent : Chat;
  const isHighlighted = Boolean(item.isUnread && item.lastMessageAuthor === 'user');

  const handleOpen = () => {
    onOpen(item.id);
  }

  return (
    <div className={cx('support-requests-table__request', {'support-requests-table__request_highlighted': isHighlighted})}>
      <div className='support-requests-table__chips'>
        <Chip label={item.category} />
        {item.step && <Chip label={item.step} />}
      </div>
      <Typography
        variant='body2'
        className='support-requests-table__subject'
        onClick={handleOpen}
        style={{color: REQUEST_SUBJECT_COLOR}}
        sx={{letterSpacing: 0, lineHeight: '20px'}}
      >
        {item.subject}
      </Typography>
      <div className='support-requests-table__message'>
        <LastMessageIcon className='support-requests-table__message-icon' />
        <Typography
          variant='body2'
          style={{color: REQUEST_MESSAGE_COLOR}}
          sx={{letterSpacing: 0, lineHeight: '20px'}}
        >
          {item.lastMessage}
        </Typography>
      </div>
    </div>
  );
};

export default Request;
